<main class="min-h-screen">
  <router-outlet></router-outlet>
</main>

<app-support-widget></app-support-widget>